 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"framework","1":"styles","2":"1bfc9850","3":"8cc0c180","4":"aebe953e39b0bfc59e555a2812396be82490249d","5":"ffb5a5a7e69bf75cca8b327a41ecd602120df174","6":"5e2a4920","7":"6e0075ae88aa395c27e16d264005163d1a7f913a","8":"d64684d8","9":"d7eeaac4","10":"92f938de001e4b155d791599a7cd949d6a68c3b6","11":"32b1698cd1c7b3e76691acdba34ea41b31af1f5c","12":"fd407b078973382f981ef969798782b789c996bf","13":"a945495aefc6f2866ea2ac60a46dc5c489b4ab37","26":"252f366e","27":"78e521c3","29":"component---src-pages-404-js","30":"component---src-pages-artists-js","31":"component---src-pages-artwork-js","32":"component---src-pages-buy-js","33":"component---src-pages-confirm-js","34":"component---src-pages-contemporary-js","35":"component---src-pages-exceptional-sales-js","36":"component---src-pages-exhibitions-js","37":"component---src-pages-historical-js","38":"component---src-pages-homepage-js","39":"component---src-pages-index-js","40":"component---src-pages-news-js","41":"component---src-pages-password-reset-js","42":"component---src-pages-subscribe-successful-js","43":"component---src-pages-user-favourite-artists-js","44":"component---src-pages-user-index-js","45":"component---src-pages-user-login-js","46":"component---src-pages-user-register-js","47":"component---src-pages-user-saved-artworks-js","48":"component---src-pages-virtual-tours-js","49":"component---src-templates-artist-js","50":"component---src-templates-artwork-js","51":"component---src-templates-exhibition-js","52":"component---src-templates-info-page-js","53":"component---src-templates-story-js","55":"reactPlayerDailyMotion","56":"reactPlayerFacebook","57":"reactPlayerFilePlayer","58":"reactPlayerKaltura","59":"reactPlayerMixcloud","60":"reactPlayerMux","61":"reactPlayerPreview","62":"reactPlayerSoundCloud","63":"reactPlayerStreamable","64":"reactPlayerTwitch","65":"reactPlayerVidyard","66":"reactPlayerVimeo","67":"reactPlayerWistia","68":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"8d3ecd84a2e99181372b","1":"29147cbc04bbc833f6a0","2":"ffa9b9d7f847cfb5787e","3":"d3193e99619f5350501b","4":"c995474d0361966aef34","5":"c4a383791df457601e4f","6":"28a21e1b058cce879a24","7":"063115495b1ae3824d08","8":"24d580ce0bf2543b0d2c","9":"7c6c3d18a2000f567149","10":"bbe8c6ea263e532c898b","11":"5b13bb43899d78e77475","12":"c2e0c6529d7949002b86","13":"ce3f4e617ddeb8b95aca","14":"f24b7c3e0db8dd6c3b8d","16":"8cc23e65d68524182d07","17":"7d638698f669d310e2e6","18":"1e9b75c13b2865771cbb","19":"04b41848401b5bef602f","20":"7aa6664041540240aee5","21":"8588c4c7799a75ff76ec","22":"1dbdad3a6aef47398d76","23":"7b8a7c2398243e9209fa","24":"38141dab63d332e125cb","25":"f6d030fb00bd302e775f","26":"7add0ef72ce6341d4835","27":"bafbe525c150aa25170d","29":"30d6e6984813718c369b","30":"5407bde8d7b72d438b8a","31":"f9ccd274ef575c3a9233","32":"2ec0c892de3d5def6876","33":"f38693f5236d6cd79a83","34":"501b5ebd9f91a3ba504a","35":"673194a113ebfbffa367","36":"6099025c060613ad674f","37":"5dddcaadbf76cf59e6cf","38":"a4743affa6f79ac608a4","39":"f6d6ef163b94c8e2acba","40":"52b8942b8cd79a78d858","41":"ad02a98d69db9a01366d","42":"52c1927ad74bf2a4f511","43":"05a3ec75e721c4d83b3f","44":"bc2809abb88824364720","45":"a53d0dec7f31e7e24965","46":"e687b473620800d1524f","47":"fe4e6f967ad398b2f6c0","48":"4320dfd50776629bd5db","49":"f0d7782688ceb60b38db","50":"0862f610b6c55fe67306","51":"2c410a91324162af71f0","52":"e4c1219c94ceca9b5059","53":"43c5edf8451a97a9a856","55":"abeb3b111b07d92881a1","56":"5d714a6c5abeaef3122b","57":"96d31367f54755e3688d","58":"03d58ea760fb6ed25b04","59":"02548571c6fde55b5f61","60":"4c3b66f83f5d5c7ac916","61":"d693d5836ed3b2fd23de","62":"1a2c8b56c75326ce646e","63":"c9242b5a90b3b81fa7ff","64":"972633a82287cf099b31","65":"bacf0fb0c28c8ae07de6","66":"23f597b285c78308342b","67":"a9c5ab2a2bc8e2d2238f","68":"e1d2a0a63b257c53de72","69":"051b261582bf868eb0c1","70":"03d9dbb52f23f99bfb1b","71":"dcf98cabca58be07bcb3","72":"38bb1e5e2f776ec7a1a4","73":"c18fbe72662a9ed23bea","74":"ff8275fe27fd11c75862","75":"cb365198e530966f28b3","76":"ab6a283fa5a07c7a3a7a","77":"0bff3860d700730f90af","78":"bc59088bae2c20457470","79":"5ab6798368b5f83eba68","80":"26495dd4bf4f2239b029","81":"70321bdbffc5881b3f01","82":"0cd7e64d2a7df5396564","83":"9296b704c9532bcc4dd5","84":"51fc004124729b4ea246"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"framework","1":"styles","2":"1bfc9850","3":"8cc0c180","4":"aebe953e39b0bfc59e555a2812396be82490249d","5":"ffb5a5a7e69bf75cca8b327a41ecd602120df174","6":"5e2a4920","7":"6e0075ae88aa395c27e16d264005163d1a7f913a","8":"d64684d8","9":"d7eeaac4","10":"92f938de001e4b155d791599a7cd949d6a68c3b6","11":"32b1698cd1c7b3e76691acdba34ea41b31af1f5c","12":"fd407b078973382f981ef969798782b789c996bf","13":"a945495aefc6f2866ea2ac60a46dc5c489b4ab37","26":"252f366e","27":"78e521c3","29":"component---src-pages-404-js","30":"component---src-pages-artists-js","31":"component---src-pages-artwork-js","32":"component---src-pages-buy-js","33":"component---src-pages-confirm-js","34":"component---src-pages-contemporary-js","35":"component---src-pages-exceptional-sales-js","36":"component---src-pages-exhibitions-js","37":"component---src-pages-historical-js","38":"component---src-pages-homepage-js","39":"component---src-pages-index-js","40":"component---src-pages-news-js","41":"component---src-pages-password-reset-js","42":"component---src-pages-subscribe-successful-js","43":"component---src-pages-user-favourite-artists-js","44":"component---src-pages-user-index-js","45":"component---src-pages-user-login-js","46":"component---src-pages-user-register-js","47":"component---src-pages-user-saved-artworks-js","48":"component---src-pages-virtual-tours-js","49":"component---src-templates-artist-js","50":"component---src-templates-artwork-js","51":"component---src-templates-exhibition-js","52":"component---src-templates-info-page-js","53":"component---src-templates-story-js","55":"reactPlayerDailyMotion","56":"reactPlayerFacebook","57":"reactPlayerFilePlayer","58":"reactPlayerKaltura","59":"reactPlayerMixcloud","60":"reactPlayerMux","61":"reactPlayerPreview","62":"reactPlayerSoundCloud","63":"reactPlayerStreamable","64":"reactPlayerTwitch","65":"reactPlayerVidyard","66":"reactPlayerVimeo","67":"reactPlayerWistia","68":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"1fccd1a7f0f02839c381","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
